import React from "react";
import { Modal, Button } from "react-bootstrap";

interface HelpModalProps {
  show: boolean;
  onHide: () => void;
}

const HelpModal: React.FC<HelpModalProps> = ({ show, onHide }) => {
  // Link do vídeo (pode ser alterado conforme necessário)
  const videoUrl = "https://caoadilvpgbrhjcwppyv.supabase.co/storage/v1/object/public/arquivos/video%20de%20ajuda%20crm/WhatsApp%20Video%202025-03-28%20at%2018.20.46.mp4";

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Precisa de ajuda?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ textAlign: "center" }}>
          <video width="100%" controls>
            <source src={videoUrl} type="video/mp4" />
            Seu navegador não suporta o elemento de vídeo.
          </video>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HelpModal;
